import React, { useContext, useRef } from 'react';
import { useRouter } from 'next/router';
import Touchable from 'plaid-threads/Touchable';
import SearchIcon from 'plaid-threads/Icons/Search';
import cx from 'classnames';

import { usePrevious } from 'src/hooks';
import Context from 'src/contexts/docs';

import styles from 'src/components/docs/Search/index.module.scss';
import SearchParent from './SearchParent';

const SearchPlaceholder: React.FC<{ showFinn?: boolean }> = ({
  showFinn = false,
}) => {
  const { dispatch, showSearch } = useContext(Context);
  const searchRef = useRef(null);
  const previousShowSearch = usePrevious(showSearch);
  const { pathname } = useRouter();
  const previousPathname = usePrevious(pathname);

  React.useEffect(() => {
    if (previousShowSearch && !showSearch && searchRef.current != null) {
      searchRef.current.focus();
    }
  }, [showSearch, previousShowSearch, searchRef]);

  React.useEffect(() => {
    if (previousPathname !== pathname && searchRef.current != null) {
      searchRef.current.blur();
    }
  }, [searchRef, pathname, previousPathname]);

  return (
    <span className={cx(styles.inputWrapper, showSearch && styles.hidden)}>
      <Touchable
        className={styles.button}
        ref={searchRef}
        onClick={() =>
          dispatch({
            type: 'SET_SEARCH_VISIBILITY',
            payload: {
              visibility: true,
              openSearchClicked: true,
            },
          })
        }
      >
        {showFinn ? 'Search or Ask a Question' : 'Search'}{' '}
        <SearchIcon className={styles.icon} />
      </Touchable>
    </span>
  );
};

const Search: React.FC = () => {
  return (
    <>
      <SearchPlaceholder showFinn={true} />
      <SearchParent showFinn={true} />
    </>
  );
};

Search.displayName = 'CoreExchangeSearch';
export default Search;
